import Vue from 'vue'

Vue.prototype.$nameProgress = {
  processing: 'processing',
  waiting: 'waiting',
  done: 'done',
}

Vue.prototype.$statusConst = {
  creation: 'Order creation',
  received: 'Received',
  approved: 'Shipping approved',
  paid: 'Shipping paid',
  departed: 'Departed',
  arrived: 'Arrived',
}

Vue.prototype.$statusId = {
  waiting: 1,
  received: 14,
  shippingApproved: 4,
  shippingPaid: 10,
  prepareForShipment: 9,
  departed: 5,
  arrived: 6,
  pickedUp: 7,
  returnRequest: 15,
  returnOrder: 16,
  pendingApproval: 11,
  pendingPayment: 2,
  paid: 3,
  orderedAndWaiting: 8
}


Vue.prototype.$tabName = {
  inProgress: 'inProgress',
  completed: 'completed',
  us: 'us',
  de: 'de',
  kr: 'kr',
  mn: 'mn',
  jp: 'jp',
  personalInfo: 'personalInfo',
  addressBook: 'addressBook',
  paymentProfiles: 'paymentProfiles',
  pointsHistory: 'pointsHistory'
}

Vue.prototype.$splitStatus = {
  none: 0,
  requested: 1,   //original order while split
  split: 2,       //original order after split
  pending: 3,     //new order while split
  completed: 4    //new order after split
}

Vue.prototype.$combineStatus = {
  none: 0,
  pending: 1,     //while combine
  combined: 2     //after combine
}

Vue.prototype.$filterName = {
  filterInProgress: 'inProgress',
  filterCompleted: 'completed',
}

Vue.prototype.$checkRoute = {
  addOrder: '/orders/add'
}

Vue.prototype.$orderType = {
  online: 'online',// 0~
  shipment: 'shipment',// 1
  myShipmentLabel: 'my-shipment-label',// 2
  myShipmentDropOff: 'my-shipment-drop-off'// 3
}

Vue.prototype.$flowType = {
  online: 0,
  shipment: 1,
  myShipmentLabel:  2,
  myShipmentDropOff: 3
}

Vue.prototype.$recipientType = {
  personal:  0,
  commercial: 1
}

Vue.prototype.$validateFiles = {
  maxImgSize: 10000,
  maxPdfSize: 10000,
}

Vue.prototype.$typeFiles = {
  pdf: 'application/pdf',
}


Vue.prototype.$countryId = {
  mn: 159,
  kr: 223,
  us: 253,
}

Vue.prototype.$countryIso2 = {
  mn: 'MN',
  kr: 'KR',
  us: 'US',
}

Vue.prototype.$defaultValue = {
  color: '#008FEE',
}

Vue.prototype.$invoiceType = {
  PayForBase: 1,
  PayForShipping: 3,
  PayForExpensesCustoms: 4,
  PayForConsolidatedShipping: 5,
  MyShippingInvoice: 7,
}

Vue.prototype.$invoiceTypeValue = [
  {key: Vue.prototype.$invoiceType.PayForBase, value: 'Merchandise'},
  {key: Vue.prototype.$invoiceType.PayForShipping, value: 'Shipping'},
  {key: Vue.prototype.$invoiceType.PayForExpensesCustoms, value: 'Pay For Custom'},
  {key: Vue.prototype.$invoiceType.PayForConsolidatedShipping, value: 'Pay For Consolidated Shipping'},
  {key: Vue.prototype.$invoiceType.MyShippingInvoice, value: 'Pay For My Shipping Invoice'}
]

Vue.prototype.$formType = {
  normal: 0,
  additional: 1
}

Vue.prototype.$shipmentMethod = {
  air: 0,
  ocean: 1,
  sal: 2,
  express: 3,
}

Vue.prototype.$shipmentMethodName = [
  'Air', 'Ocean', 'SAL', 'Express'
]

Vue.prototype.$shipmentType = {
  pickUp: 2,
  delivery: 1,
}

Vue.prototype.$currencyId = {
  USD: 1,
  EUR: 2,
}

Vue.prototype.$paymentTypes = {
  checkout: "checkout",
  pay_pal: "payPal",
  pay_by_point: "payByPoint",
  pay_cod: "payCashOnDelivery",
  bank_transfer: "bank_transfer",
  bit_pay: "bitPay",
}

Vue.prototype.$invoicePaidType = {
  payPal: 1,
  checkout: 3,
  payByPoint: 4,
  payCashOnDelivery: 15,
  bitPay: 24,
}

Vue.prototype.$siteSelection = {
  legacyAdmin: 1,
  newAdmin: 2,
  user: 3,
}
